<template>
  <div :class="['item-hotel', { horizonal: type === 'horizonal' }]">
    <div class="hotel-cover">
      <img src="@/assets/images/base.png" alt="demo"/>
      <div class="hotel-title">
        <h3>
          <a href="#">
            スーペリアナチュラルツイン
          </a>
        </h3>
      </div>
    </div>
    <div class="hotel-content">
      <div class="hotel-title">
        <h3>
          <a href="#">
            スーペスーペリアナチュラルツインスーペスーペリアナチュラルツインスーペスーペリアナチュラルツインスーペスーペリアナチュラルツインスーペスーペリアナチュラルツインスーペスーペリアナチュラル
          </a>
        </h3>
      </div>
      <div class="hotel-meta-wrap">
        <div class="hotel-meta">
          <div class="meta-item">
            <i class="icon icon-bor-people" />
            <span>定員 2名</span>
          </div>
          <div class="meta-item">
            <i class="icon icon-bor-bed" />
            <span>キングベッド 1台</span>
          </div>
          <div class="meta-item">
            <i class="icon icon-bor-m2" />
            <span>部屋のサイズ 47.5㎡</span>
          </div>
          <div class="meta-item">
            <i class="icon icon-bor-no-smoking" />
            <span>禁煙</span>
          </div>
        </div>
        <div class="hotel-price" v-bind:class="{hide: this.isHide}">
          <span>大人1人／1泊の料金</span>
          <strong>15,000円～</strong>
        </div>
      </div>
      <div v-if="type === 'horizonal'" class="room-actions">
        <a-space>
          <button class="c-btn btn-white btn-sm">お部屋の詳細</button>
          <button class="c-btn btn-white btn-sm">空室カレンダー</button>
        </a-space>
      </div>
      <div v-else class="hotel-actions">
        <a-button size="large" @click="$router.push({path: `/menus/${renderData.menu_no}/plans/${renderData.plan_id}/rooms/${renderData.room_id}/`})">詳細を見る</a-button>

        <a-tooltip overlayClassName="tooltip-red">
          <template slot="title">
            残りわずか
          </template>
          <a-button class="btn-dark ml-4" size="large" @click="$router.push('#')">予約する</a-button>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HotelItem',
  props: 
    ['type', 'data', 'hidePriceProps'],
  setup() {
    return {}
  },
  data() {
    return {
      renderData: null,
      isHide: this.hidePriceProps || false
    }
  },
  mounted() {
    if (this.data) {
      this.renderData = this.data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";

/deep/ .ant-btn-lg {
  font-weight: 700;
  color: #1F2021;
}
/deep/ .btn-dark {
  background-color: #434547;
  color: #ffffff;
}
</style>

<style lang="scss">
.tooltip-red .ant-tooltip-inner {
  background-color: #DA291C;
  color: #ffffff;
}
.tooltip-blue .ant-tooltip-inner {
  background-color: #259BEE;
  color: #ffffff;
}
</style>